export type WelcomeUser = {
  id: number;
  name: string;
  surname: string;
  email: string;
};

export type WelcomeProject = {
  id: number;
  name: string;
  devurl: string | null;
  api_key: string;
  pusherChannelName: string;
};

export type WelcomeToBugherdProps = {
  user: WelcomeUser;
  organization: { id: number };
  project: WelcomeProject;
  apiKey: string;
  bugherdUrl: string;
  activeExperiments: string[];
  embeddedSidebarUrl: string;
  pusherApiKey: string;
  pusherChannelAuthEndpoint: string;
};

export enum WizardStep {
  YOUR_PROJECT = 0,
  INSTALL = 1,
  TRY = 2
}

export const STEP_PATHS: Record<WizardStep, string> = {
  [WizardStep.YOUR_PROJECT]: '/create',
  [WizardStep.INSTALL]: '/install',
  [WizardStep.TRY]: '/try'
};

// Demo site used when a trial user doesn't have a website ready to test on.
export const DEMO_SITE_URL = 'https://demo-site.bugherd.com/';

// The demo site reads the trial project's API key from the ?apikey= query
// string and injects the BugHerd script at runtime, so the user can try
// BugHerd on the demo site without installing anything themselves.
export const demoSiteUrlWithApiKey = (apiKey: string): string =>
  `${DEMO_SITE_URL}?apikey=${encodeURIComponent(apiKey)}`;
